<template>
  <div class="container-fluid customer-media-container">
    <!-- home img
    <b-row>
      <b-col lg="2" md="5" cols="5" class="mx-auto">
       
      </b-col>
    </b-row> -->
    <!-- title -->
    <b-row>
      <b-col lg="6" offset-lg="3" class="">
        <b-row class="mt-md-4 mt-1">
          <b-col
            xl="2"
            lg="2"
            offset-lg="0"
            md="2"
            offset-md="1"
            class="text-center px-0"
          >
            <img
              class="imageTitleDY"
              src="@/assets/images/doom-yoga/doom-yoga-login-image2.png"
              alt="doomyoga Logo"
            />
          </b-col>
          <b-col
            xl="10"
            lg="10"
            md="8"
            class="d-flex align-items-center text-center"
          >
            <h2 class="welcomeUserHomeH2DY mb-0">Release and Relax</h2>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!-- <MediaSimpleCardList
      :list_title="playlist_title"
      :list_items="tracks"
    /> -->
    <b-card
      class="card-transparent-background card-media-container-doomyoga mt-1"
      :title="playlist_title"
    >
      <CoolLightBox
        class="customer-media-lightbox-doomyoga"
        :items="tracks"
        :index="index"
        loop
        thumbsPosition="bottom"
        :srcName="'video_src'"
        @close="index = null"
        @on-change="clickTrack"
      >
      </CoolLightBox>

      <div class="images-wrapper">
        <b-row>
          <b-col
            xl="2"
            lg="2"
            md="4"
            sm="6"
            cols="6"
            class="image"
            v-for="(item, itemIndex) in tracks"
            :key="itemIndex"
          >
            <SimpleMediaCard
              client_name="DY"
              :title="item.title"
              :duration="item.duration"
              :img_src="item.thumb"
              @click.native="setIndex(itemIndex)"
            />
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import MediaSimpleCardList from "@/components/media_components/MediaSimpleCardList.vue";
import SimpleMediaCard from "@/components/media_components/SimpleMediaCard.vue";
import CoolLightBox from "vue-cool-lightbox";
import axios from "axios";

export default {
  name: "DoOmYogaCustomerMovementPlaylist",
  components: { MediaSimpleCardList, CoolLightBox, SimpleMediaCard },
  data() {
    return {
      login_user: window.localStorage.getItem("user"),
      user_name: "",
      playlist_title: "Playlist 1",
      playlist_id: null,

      tracks: [
        // {
        //   id: 1,
        //   title: " Mental Training",
        //   duration: "50 Min 30 sec",
        //   mediaType: "webVideo",
        //   autoplay: false,
        //   mediaType: "video",
        //   video_src: "https://www.w3schools.com/html/mov_bbb.mp4",
        //   thumb:
        //     "https://images.unsplash.com/photo-1614925861087-aa06270091b3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OXx8YmxhY2slMjBhbmQlMjB3aGl0ZSUyMG5hdHVyZXxlbnwwfHwwfHw%3D&w=1000&q=80",
        // },
        // {
        //   id: 2,
        //   title: " Mental Training 2",
        //   duration: "5 Min 30 sec",
        //   mediaType: "webVideo",
        //   autoplay: false,
        //   mediaType: "video",
        //   video_src:
        //     "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4",
        //   thumb:
        //     "https://images.unsplash.com/photo-1565301660306-29e08751cc53?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8YmxhY2slMjBhbmQlMjB3aGl0ZSUyMG5hdHVyZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60",
        // },
      ],
      index: null,
    };
  },
  mounted() {
    this.playlist_id = this.$route.params.id;
    console.log(this.playlist_id);
    // this.selected_category = [Number(this.$route.params.id)];
    this.getVideosRequest();
  },
  methods: {
    setIndex(index) {
      console.log("click card ", index);
      this.index = index;
    },
    clickTrack(index) {
      // alert("click track " + index);
    },
    getVideosRequest() {
      axios
        .get("/media/library/category/" + this.playlist_id, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: "DY",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          console.log(response.data.library_media);
          console.log(response.data.library_media.length);
          this.playlist_title = response.data.title;
          this.tracks = [];
          for (let i = 0; i < response.data.library_media.length; i++) {
            let media = response.data.library_media[i];
            this.tracks.push({
              id: media.id,
              title: media.title,
              description: media.description,
              duration: media.time_duration,
              mediaType: "webVideo",
              autoplay: true,
              video_src: media.media.full_path,
              thumb: media.cover_image.full_path,
            });
          }

          // this.tracks = this.tracks.concat(this.tracks);
          // this.tracks = this.tracks.concat(this.tracks);
        });
    },
  },
};
</script>

<style scoped::v-deep >
</style>


// WEBPACK FOOTER //
// src/components/doom_yoga/customer/Movement/VideosList.vue